import { ModelBase } from 'store/model-base';

export class CmsDeviceUpgrade extends ModelBase {
    public static storeName: string = 'cmsDeviceUpgrade';

    public header: string;
    public anyTimeUpgradeHeader: string;
    public upgradeDeviceIcon: CmsMediaImage;
    public switchDeviceIcon: CmsMediaImage;
    public upgradeDevice: CmsUpgradeDevice;
    public switchDevice: CmsSwitchDeviceCollection;
    public extendedPromoDetail: CmsExtendedPromoDetail;
    public shopNowButton: string;
    public shopNowButtonXoe: string;
    public shopPhonesButton: string;
    public shopPhonesButtonXoe: string;
    public makePaymentButton: string;
    public makepaymentUrl: string;
    public findStoreLink: string;
    public cbmMakepaymentUrlSmb: string;
    public cbmMakepaymentUrlOs: string;
}
